import { defineComponent as _defineComponent } from 'vue'
import {TokenReservation, usePublicSalesStore} from "@/store/publicSales.store";
import CoinAmount from "@/components/commons/CoinAmount.vue";
import {onBeforeMount, onUnmounted, ref} from "vue";
import {BLOCKCHAIN_STATUS, CHAIN_NAME, PAYMENT_TYPE, RESERVATION_STATUS, TOKEN_NAME, Transaction, TRANSACTION_CURRENCY, TRANSACTION_STATUS} from "@/models/saleServiceCommons";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import {useI18n} from "vue-i18n";
import {addDotsInsideTooLongString} from "@/utils/string-formatter";
import moment from "moment/moment";
import CountryFlag from "vue-country-flag-next";
import {BigDecimal} from "@/models/store/big.decimal";
import {bool} from "yup";


export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationInfo',
  props: {
    transaction: { type: Object, required: true }
  },
  emits: ['pay', 'cancelAllocation'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

let timeToPassId = 0;

const remainingTime = ref(-1);
const i18n = useI18n();

onBeforeMount(() => {
  calculateRemainingTime();
  timeToPassId = window.setInterval(calculateRemainingTime, 1000);
  const values = Object.values(TRANSACTION_CURRENCY);
  values.forEach((value, _) => {
    calculateC4EAmount(value).then(res => {
      exchangeRateMap.set(value, res);
    });
  });
});

onUnmounted(() => {
  window.clearInterval(timeToPassId);
});

const exchangeRateMap = new Map<TRANSACTION_CURRENCY, BigDecimal>();
const getReservationStatusClass = (transaction: TokenReservation, remainingTime: number) => {
  switch (transaction.status) {
    case RESERVATION_STATUS.DECLARED:
      if(remainingTime < 0 ){
        return 'payment-status-expired';
      }
      return 'payment-status-declared';
    case RESERVATION_STATUS.CANCELED:
      return 'payment-status-cancelled';
    case RESERVATION_STATUS.PARTIALLY_PAID:
      if(remainingTime < 0 ){
        return 'payment-status-expired';
      }
      return 'payment-status-partially_paid';
    case RESERVATION_STATUS.REJECTED:
      return 'payment-status-rejected';
    case RESERVATION_STATUS.OVERPAID:
      return 'payment-status-overpaid';
    case RESERVATION_STATUS.COMPLETED:
      return 'payment-status-completed';

  }
};

const getTransactionStatusClass = (status: TRANSACTION_STATUS) => {
  switch (status) {
    case TRANSACTION_STATUS.NOT_VERIFIED:
      return 'transaction_status-entered';
    case TRANSACTION_STATUS.OK:
      return 'transaction_status-ok';
    default:
      return 'transaction_status-error';
  }
};

const getReservationIcon = (transaction: TokenReservation, remainingTime: number) => {
  switch (transaction.status) {
    case RESERVATION_STATUS.DECLARED:
      if(remainingTime < 0 ){
        return 'AlarmClockOff';
      }
      return 'PlusSquare';
    case RESERVATION_STATUS.CANCELED:
      return 'XCircle';
    case RESERVATION_STATUS.PARTIALLY_PAID:
      if(remainingTime < 0 ){
        return 'AlarmClockOff';
      }
      return 'ArrowDownSquare';
    case RESERVATION_STATUS.REJECTED:
      return 'XCircle';
    case RESERVATION_STATUS.OVERPAID:
      return 'ArrowUpSquare';
    case RESERVATION_STATUS.COMPLETED:
      return 'CheckSquare';
    default:
      return '';

  }
};

const emit = __emit;
// function getPaymentType(){
//   switch (props.transaction.paymentType){
//     case paymentType.Crypto: return 'Crypto';
//     case paymentType.StandardCurrency: return 'USD or EUR';
//     case paymentType.updating: return '';
//   }
// }
// function getStatusColor(){
//   switch (props.transaction.status){
//     case RESERVATION_STATUS.DECLARED: return `#858585`;
//     case RESERVATION_STATUS.COMPLETED: return `#19B15D`;
//     case RESERVATION_STATUS.CANCELED: return `#E02626`;
//   }
// }

const getFlagSelector = (currency: TRANSACTION_CURRENCY) => {
  switch (currency) {
    case TRANSACTION_CURRENCY.PLN:
      return 'pl';
    case TRANSACTION_CURRENCY.EUR:
      return 'eu';
    case TRANSACTION_CURRENCY.USD:
      return 'us';
  }
};
const getRoundName = (roundId: number) => {
  return usePublicSalesStore().roundInfoMap.get(roundId)?.roundInfo.name;
};
function submit(){
  console.log('submit');
  emit('pay');
}

const cancelAllocation = () => {
  emit('cancelAllocation');
};

// function isExpiredAllocation(transaction: TokenReservation, remainingTime : number):boolean{
//
// }

function showAllocationCancelButton(transaction: TokenReservation, reminingTime : number) : boolean{
  return transaction.status == RESERVATION_STATUS.DECLARED && transaction.transactions?.length == 0  && !isExpired(reminingTime);
}

function showRemainingTime(transaction: TokenReservation, remainingTime : number): boolean {
  return ((transaction.status === RESERVATION_STATUS.DECLARED || transaction.status === RESERVATION_STATUS.PARTIALLY_PAID) && transaction.reservationEndTime) && !isExpired(remainingTime);
}
function showExpirationDate(transaction: TokenReservation, remainingTime : number): boolean{
  return ((transaction.status === RESERVATION_STATUS.DECLARED || transaction.status === RESERVATION_STATUS.PARTIALLY_PAID) && transaction.reservationEndTime) && isExpired(remainingTime);
}

function getAllocationInfoStatus(transaction: TokenReservation, remainingTime : number){
  console.log("getAllocationInfoStatus: " + JSON.stringify(transaction) + "  " + JSON.stringify(remainingTime) );
  if( (transaction.status === RESERVATION_STATUS.DECLARED || transaction.status === RESERVATION_STATUS.PARTIALLY_PAID)  && transaction.reservationEndTime && isExpired(remainingTime)){
    return i18n.t('ENUMS.RESERVATION_STATUS.EXPIRED');
  } else {
    return i18n.t('ENUMS.RESERVATION_STATUS.' + transaction.status);
  }
}

function isExpired(remainingTime : number){
  return remainingTime < 0;
}

function calculateRemainingTime(){
  const now = new Date(Date.now());
  remainingTime.value = props.transaction.reservationEndTime.getTime() - now.getTime();
}

function formatRemainingTime(remainingTime : number){
  if(remainingTime == undefined){
    return "";
  }
  const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
  return `${days}D ${hours}H ${minutes}M ${seconds}S`;
}

const formattedDate = (value: Date) => {
  return moment(value).format('DD.MM.YYYY HH:mm:ss');
};

const calculateC4EAmount = async (currency: TRANSACTION_CURRENCY): Promise<BigDecimal> => {
  const amountInFiat = 100;
    const requestOptions = {
    method: "POST",
    headers: {"Content-Type": "application/json", "Ari10-Widget-Id": "41875703-9ee2-4729-9d51-e574c61467c3"},
    body: JSON.stringify({"offeredCurrencyCode": currency, "offeredAmount": amountInFiat})
  };
  let amount = new BigDecimal(0);
  await fetch("https://xqkzzpmim7.eu-west-1.awsapprunner.com/currencies/USDT/calculate", requestOptions)
    .then(response => response.json())
    .then(data => {
      const c4eTOUSDT = usePublicSalesStore().getC4eToUSD;

      if (c4eTOUSDT != undefined) {

        amount = new BigDecimal(data.amount).divide(c4eTOUSDT).divide(new BigDecimal(amountInFiat));
      }
    });
  return amount;
};

const __returned__ = { props, get timeToPassId() { return timeToPassId }, set timeToPassId(v) { timeToPassId = v }, remainingTime, i18n, exchangeRateMap, getReservationStatusClass, getTransactionStatusClass, getReservationIcon, emit, getFlagSelector, getRoundName, submit, cancelAllocation, showAllocationCancelButton, showRemainingTime, showExpirationDate, getAllocationInfoStatus, isExpired, calculateRemainingTime, formatRemainingTime, formattedDate, calculateC4EAmount, CoinAmount, get BLOCKCHAIN_STATUS() { return BLOCKCHAIN_STATUS }, get CHAIN_NAME() { return CHAIN_NAME }, get PAYMENT_TYPE() { return PAYMENT_TYPE }, get RESERVATION_STATUS() { return RESERVATION_STATUS }, get TOKEN_NAME() { return TOKEN_NAME }, get Accordion() { return Accordion }, get AccordionTab() { return AccordionTab }, get addDotsInsideTooLongString() { return addDotsInsideTooLongString }, get CountryFlag() { return CountryFlag } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})